import { EditableDatePicker } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SEditableDatePicker = styled(EditableDatePicker)``;
